import React, { useContext, useState } from "react"
import "./EditUniversity.scss"
import { useLocation, useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { InputText } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Calendar } from "primereact/calendar"
import * as Yup from "yup"
import UniversityApi from "Api/UniversityApi"
import Country from "utils/Data/Country"
import { Dropdown } from "primereact/dropdown"
import UserContext from "ContextProvider/UserContext"
import { ToastContainer, toast } from "react-toastify"

const EditUniversity = () => {
  document.title = "Edit University"
  const [loading, setLoading] = useState(false)
  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation("")
  const universityData = location?.state
  // const { userData } = useContext(UserContext)
  const userData = JSON.parse(localStorage.getItem("userData"))

  console.log("userData", userData)

  const [errors, setErrors] = useState({})

  // const [dialCode, phoneNumber] = universityData?.phone
  //   ? universityData?.phone?.split("-")
  //   : [null, null]

  const refinedUniversityData = {
    ...universityData,
    type: {
      name:
        universityData?.type?.charAt(0)?.toUpperCase() +
        universityData?.type?.slice(1),
      code: universityData?.type,
    },
    country: {
      name: universityData?.country,
      code: universityData?.country,
    },
    // phoneCode: {
    //   name: universityData?.country,
    //   code: universityData?.country,
    //   dialCode: dialCode,
    // },
    // phone: phoneNumber,
    ugcApproval: {
      name: universityData?.ugcApproval ? "Yes" : "No",
      code: universityData?.ugcApproval ? "Yes" : "No",
    },
    aiuAffiliation: {
      name: universityData?.aiuAffiliation ? "Yes" : "No",
      code: universityData?.aiuAffiliation ? "Yes" : "No",
    },
    verifiedStatus: {
      name:
        universityData?.verifiedStatus.charAt(0)?.toUpperCase() +
        universityData?.verifiedStatus?.slice(1),
      code:
        universityData?.verifiedStatus.charAt(0)?.toUpperCase() +
        universityData?.verifiedStatus?.slice(1),
    },
    verifiedReason: universityData?.verifiedReason
      ? universityData?.verifiedReason
      : "",
  }
  console.log(refinedUniversityData)
  const [updatedUniversityData, setUpdatedUniversityData] = useState(
    refinedUniversityData,
  )

  const handleUniverSityDataChange = (name, value) => {
    setUpdatedUniversityData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors(prevErrors => ({ ...prevErrors, [name]: "" }))
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "University", link: "#" },
    { label: "Edit University", link: "#" },
  ]
  const typeOptions = [
    { name: "Central", code: "Central" },
    { name: "State", code: "State" },
    { name: "Private", code: "Private" },
    { name: "Deemed", code: "Deemed" },
    { name: "Autonomous", code: "Autonomous" },
    { name: "Government", code: "Government" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]

  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]

  const validateUniversity = Yup.object().shape({
    universityName: Yup.string().required("University name is required"),
    displayName: Yup.string().required("Display name is required"),
    type: Yup.string()
      // .oneOf(
      //   ["central", "state", "private", "deemed", "autonomous"],
      //   "Invalid Type",
      // )
      .required("University type required"),
    yearEstablished: Yup.number()
      .typeError("Established year must be a valid number")
      .min(1800, "Year cannot be before 1800")
      .max(new Date().getFullYear(), "Year cannot be in the future")
      .required("Established year is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string()
      .matches(/^\d{6}$/, "Please enter a valid 6-digit zip code")
      .required("PinCode is required"),
    address: Yup.string().required("Address is required"),
    // phone: Yup.string()
    //   .matches(/^\+\d{1,3}[-\s]?\d{10}$/, "Invalid phone number")
    //   .required("Phone number is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    officialWebsite: Yup.string().required("officialWebsite is required"),
    // description: Yup.string().required("Description is required"),
    nirfRanking: Yup.string().required("nirfRanking is required"),
    indiaToday2023Ranking: Yup.string().required(
      "indiaToday2023Ranking is required",
    ),
    timesRanking2024: Yup.string().required("timesRanking2024 is required"),
    campusSize: Yup.string().required("campusSize is required"),
    noOfStudents: Yup.string().required("noOfStudents is required"),
    noOfDepartments: Yup.string().required("noOfDepartments is required"),
    noOfCourses: Yup.string().required("noOfCourses is required"),
    totalFaculty: Yup.string().required("totalFaculty is required"),
    ugcApproval: Yup.boolean()
      .oneOf([true, false], "Invalid UGC approval")
      .required("Choose UGC Approval"),
    aiuAffiliation: Yup.boolean()
      .oneOf([true, false], "Invalid AIU Affiliation")
      .required("Choose AIU Affiliation"),
    highlights: Yup.string().required("highlights is required"),
    aboutContent: Yup.string().required("aboutContent is required"),
  })

  const updateUniversity = () => {
    const { phoneCode, ...otherUniversityData } = updatedUniversityData
    const payload = {
      ...otherUniversityData,
      country: otherUniversityData?.country?.name,
      state: otherUniversityData?.state,
      establishedYear: new Date(
        otherUniversityData?.establishedYear,
      ).getFullYear(),
      city: otherUniversityData?.city,
      type: otherUniversityData?.type?.name?.toLowerCase(),
      aiuAffiliation:
        otherUniversityData?.aiuAffiliation?.name === "Yes" ? true : false,
      ugcApproval:
        otherUniversityData?.ugcApproval?.name === "Yes" ? true : false,
      isVerfied: otherUniversityData?.isVerified === "Approve" ? true : false,
      verifiedStatus: otherUniversityData?.verifiedStatus?.name?.toLowerCase()
        ? otherUniversityData?.verifiedStatus?.name?.toLowerCase()
        : "pending",
      verifiedReason: otherUniversityData?.verifiedReason
        ? otherUniversityData?.verifiedReason
        : "",
    }

    setLoading(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    UniversityApi.updateUniversity(payload, config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setTimeout(() => {
            navigate("/universitylist")
          }, 1000)

          toast.success(response.data.message)
        }
      })
      .catch(error => {
        setLoading(false)

        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Unable to update university"
        console.error("Error adding university:", error)
        toast.error(errorMessage)
      })

    // validateUniversity
    //   .validate(payload, { abortEarly: false })
    //   .then(() => {

    //   })
    //   .catch(err => {
    //     setLoading(false)

    //     const validationErrors = {}
    //     err.inner.forEach(error => {
    //       validationErrors[error.path] = error.message
    //     })
    //     setErrors(validationErrors)
    //   })
  }

  return (
    <div className="edit-university">
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Edit University"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="university-edit-form ">
                <div className="university-edit-inp">
                  <label htmlFor="universityName" className="label">
                    University Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="universityName"
                      value={updatedUniversityData.universityName}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "universityName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter University Name"
                      className="inp-field-box"
                    />
                    {errors.universityName && (
                      <small className="error">{errors.universityName}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="displayName" className="label">
                    Display Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="displayName"
                      value={updatedUniversityData.displayName}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "displayName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Display Name"
                      className="inp-field-box"
                    />
                    {errors.displayName && (
                      <small className="error">{errors.displayName}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="type" className="label">
                    Type
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={updatedUniversityData.type}
                      onChange={e =>
                        handleUniverSityDataChange("type", e.value)
                      }
                      options={typeOptions}
                      optionLabel="name"
                      placeholder="Select Type"
                      filter
                      className="inp-field-box"
                    />

                    {errors.type && (
                      <small className="error">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="yearEstablished" className="label">
                    Year Established
                  </label>
                  <div className="inp-err">
                    <Calendar
                      id="yearEstablished"
                      value={
                        universityData.yearEstablished
                          ? new Date(universityData.yearEstablished, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleUniverSityDataChange(
                          "yearEstablished",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select  Year Established"
                      className="inp-field-box"
                    />

                    {errors.establishedYear && (
                      <small className="error">{errors.establishedYear}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="country" className="label">
                    Country
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      id="country"
                      value={updatedUniversityData.country}
                      onChange={e =>
                        handleUniverSityDataChange("country", e.value)
                      }
                      options={Country}
                      optionLabel="name"
                      placeholder="Select Country"
                      filter
                      className="inp-field-box"
                    />

                    {errors.country && (
                      <small className="error">{errors.country}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="state" className="label">
                    State
                  </label>

                  <div className="inp-err">
                    <InputText
                      id="state"
                      value={updatedUniversityData.state}
                      onChange={e =>
                        handleUniverSityDataChange("state", e.target.value)
                      }
                      placeholder="Enter State"
                      className="inp-field-box"
                    />
                    {errors.state && (
                      <small className="error">{errors.state}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="username" className="label">
                    City
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="city"
                      placeholder="Enter City"
                      value={updatedUniversityData.city}
                      onChange={e =>
                        handleUniverSityDataChange("city", e.target.value)
                      }
                      className="inp-field-box"
                    />
                    {errors.city && (
                      <small className="error">{errors.city}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="pincode" className="label">
                    Pin Code
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="pinCode"
                      value={universityData.pinCode}
                      onChange={e =>
                        handleUniverSityDataChange("pinCode", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter Pin Code"
                      className="inp-field-box"
                    />
                    {errors.zipCode && (
                      <small className="error">{errors.pinCode}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="address" className="label">
                    Address
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="address"
                      value={updatedUniversityData.address}
                      onChange={e =>
                        handleUniverSityDataChange("address", e.target.value)
                      }
                      placeholder="Enter Address"
                      className="inp-field-box"
                    />

                    {errors.address && (
                      <small className="error">{errors.address}</small>
                    )}
                  </div>
                </div>

                {/* <div className="university-edit-inp">
                  <label htmlFor="phoneNumber" className="label">
                    Phone
                  </label>

                  <div className="inp-err">
                    <div className="p-inputgroup  phone-number ">
                      <Dropdown
                        id="phone"
                        value={updatedUniversityData.country}
                        options={Country}
                        optionLabel="dialCode"
                        placeholder="+XX"
                        filter
                      />
                      <InputNumber
                        id="phoneNumber"
                        value={updatedUniversityData.phone}
                        onChange={e =>
                          handleUniverSityDataChange("phone", e.value)
                        }
                        useGrouping={false}
                        placeholder="Enter Phone Number"
                      />
                    </div>

                    {errors.phone && (
                      <small className="error">{errors.phone}</small>
                    )}
                  </div>
                </div> */}
                <div className="university-edit-inp">
                  <label htmlFor="email" className="label">
                    Email
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="email"
                      value={updatedUniversityData.email}
                      onChange={e =>
                        handleUniverSityDataChange("email", e.target.value)
                      }
                      placeholder="Enter Email"
                      className="inp-field-box"
                    />
                    {errors.email && (
                      <small className="error">{errors.email}</small>
                    )}
                  </div>
                </div>
                {/* <div className="university-edit-inp">
                  <label htmlFor="website" className="label">
                    Website
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="website"
                      value={updatedUniversityData.website}
                      onChange={e =>
                        handleUniverSityDataChange("website", e.target.value)
                      }
                      placeholder="Enter Website"
                      className="inp-field-box"
                    />
                    {errors.website && (
                      <small className="error">{errors.website}</small>
                    )}
                  </div>
                </div> */}
                <div className="university-edit-inp">
                  <label htmlFor="officialWebsite" className="label">
                    Official Website
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="officialWebsite"
                      value={universityData.officialWebsite}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "officialWebsite",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Official Website"
                      className="inp-field-box"
                    />
                    {errors.officialWebsite && (
                      <small className="error">{errors.officialWebsite}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="campusSize" className="label">
                    Campus Size
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="campusSize"
                      value={universityData.campusSize}
                      onChange={e =>
                        handleUniverSityDataChange("campusSize", e.target.value)
                      }
                      placeholder="Enter CampusSize"
                      className="inp-field-box"
                    />
                    {errors.campusSize && (
                      <small className="error">{errors.campusSize}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="noOfStudents" className="label">
                    No Of Students
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="noOfStudents"
                      value={universityData.noOfStudents}
                      onChange={e =>
                        handleUniverSityDataChange("noOfStudents", e.value)
                      }
                      placeholder="Enter No Of Students"
                      className="inp-field-box"
                    />
                    {errors.noOfStudents && (
                      <small className="error">{errors.noOfStudents}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="noOfDepartments" className="label">
                    No Of Departments
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfDepartments"
                      value={universityData.noOfDepartments}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "noOfDepartments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Departments"
                      className="inp-field-box"
                    />
                    {errors.noOfDepartments && (
                      <small className="error">{errors.noOfDepartments}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="noOfCourses" className="label">
                    No Of Courses
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfCourses"
                      value={universityData.noOfCourses}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "noOfCourses",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Courses"
                      className="inp-field-box"
                    />
                    {errors.noOfCourses && (
                      <small className="error">{errors.noOfCourses}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="totalFaculty" className="label">
                    Total Faculty
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalFaculty"
                      value={universityData.totalFaculty}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "totalFaculty",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Total Faculty"
                      className="inp-field-box"
                    />
                    {errors.totalFaculty && (
                      <small className="error">{errors.totalFaculty}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="nirfRanking" className="label">
                    NIRF Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="nirfRanking"
                      value={universityData.nirfRanking}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "nirfRanking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter NIRF Ranking"
                      className="inp-field-box"
                    />
                    {errors.nirfRanking && (
                      <small className="error">{errors.nirfRanking}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                    India Today 2023 Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="indiaToday2023Ranking"
                      value={universityData.indiaToday2023Ranking}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "indiaToday2023Ranking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter India Today 2023 Ranking"
                      className="inp-field-box"
                    />
                    {errors.indiaToday2023Ranking && (
                      <small className="error">
                        {errors.indiaToday2023Ranking}
                      </small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="timesRanking2024" className="label">
                    Times Ranking 2024
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="timesRanking2024"
                      value={universityData.timesRanking2024}
                      onChange={e =>
                        handleUniverSityDataChange("timesRanking2024", e.value)
                      }
                      placeholder="Enter Times Ranking 2024"
                      className="inp-field-box"
                    />
                    {errors.timesRanking2024 && (
                      <small className="error">{errors.timesRanking2024}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <div className="inp-err ">
                    <Dropdown
                      value={updatedUniversityData.ugcApproval}
                      onChange={e =>
                        handleUniverSityDataChange("ugcApproval", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select UGC Affiliation"
                      className="inp-field-box"
                    />
                    {errors.ugcApproval && (
                      <small className="error">{errors.ugcApproval}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedUniversityData.aiuAffiliation}
                      onChange={e =>
                        handleUniverSityDataChange("aiuAffiliation", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select AIU Affiliation"
                      className="inp-field-box"
                    />
                    {errors.aiuAffiliation && (
                      <small className="error">{errors.aiuAffiliation}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="highlights" className="label">
                    Highlights
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="highlights"
                      value={universityData.highlights}
                      onChange={e =>
                        handleUniverSityDataChange("highlights", e.target.value)
                      }
                      placeholder="Enter Highlights"
                      className="inp-field-box"
                    />
                    {errors.highlights && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="aboutContent" className="label">
                    About Content
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="aboutContent"
                      value={universityData.aboutContent}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "aboutContent",
                          e.target.value,
                        )
                      }
                      placeholder="Enter About Content"
                      className="inp-field-box"
                    />
                    {errors.aboutContent && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>

                {userData.role === "manager" && (
                  <>
                    <div className="university-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={updatedUniversityData.verifiedStatus}
                          onChange={e =>
                            handleUniverSityDataChange(
                              "verifiedStatus",
                              e.value,
                            )
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                        {errors.verifiedStatus && (
                          <small className="error">
                            {errors.verifiedStatus}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="university-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={updatedUniversityData.verifiedReason}
                          onChange={e =>
                            handleUniverSityDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                        {errors.verifiedReason && (
                          <small className="error">
                            {errors.verifiedReason}
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    updateUniversity()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
                <ToastContainer />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditUniversity
